<template>
    <el-drawer 
		title="新增调查项"
		:visible.sync="drawerShow"
		:wrapperClosable="false"
		:destroy-on-close="true"
		size="800px"
        @close="close">
        <div class="drawer-content">
            <el-form :model="formData"  ref="formData" label-position="top" size="medium">                
                <el-form-item prop="questionName" label="调查项：">
					<div class="xxIpt"><span>问题：</span><el-input placeholder="请输入问题" v-model="questionName" class="ipt"  maxlength="40" show-word-limit></el-input></div>
					<div class="xxIpt">
						<span>类型：</span>
						<el-radio-group v-model="questionType" @change="changeType()">
						    <el-radio :label="1">单选</el-radio>
						    <el-radio :label="2">多选</el-radio>
						    <el-radio :label="3">文本</el-radio>
							<el-radio :label="4">上传图片</el-radio>
						</el-radio-group>
					</div>					
					 <div v-for="num in ParamsNum" :key="num" class="optionsList">
						<el-row :gutter="10" type="flex" justify="flex-start">
							<el-col :span="20">
								<el-input v-model="temp.params[num].key" placeholder="选项文案" size="small" class="ipt" maxlength="40" show-word-limit/>
							</el-col>					            
							<el-col :span="4" style="text-align: left;">					                
								<i class="el-icon-remove-outline" @click="del(num)"></i>
							</el-col>
						</el-row>
					</div>					
				   <div class="xxIpt2" v-if="questionType == 1 ||questionType == 2">
						<span>选项：</span>						
						<el-button  icon="el-icon-plus" size="mini" type="primary" @click="addOptions()">添加选项</el-button>
					</div>
                </el-form-item>  
				<el-form-item v-if="questionType == 1 || questionType == 2" >
				    <el-checkbox  :true-label="1" :false-label="0" v-model="haveOther">追加【其他】选项</el-checkbox>
				</el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
            <el-button type="primary" @click="submitOption()" >
				<template v-if="formData.questionList.length > 0 ">
					继续添加调查项
				</template>
				<template v-else>
					添加调查项
				</template>
			</el-button>
        </div>
    </el-drawer>
</template>
<script>

export default {
    props:{
        formData:{
            type: Object,
            default: null
        }
    },
    data() {		
        return {
           drawerShow: false,		  	   
		   optionsName:[],		   
		   questionName:'',
		   questionType:1,
		   haveOther:0,
		   innerIndex:0,		   
		   temp: {
			   params: [{key:''}]
		   },
		   ParamsNum: 0		   
        }
    },
	
    methods: {
        close() {
            this.questionName = ''
            this.questionType = 1                      
			this.drawerShow = false;
			this.ParamsNum = 0			
			this.temp.params.splice(1,this.temp.params.length-1)			
			this.temp.params[0].key=''
        },
        show() {           
            this.drawerShow = true;
        },
		
		addOptions(){
			this.temp.params.push({key:''})
			this.ParamsNum++
		},
		del(num) {
			this.ParamsNum--
			this.temp.params.splice(num,1)
		},
		changeType(){			
			this.ParamsNum = 0
			this.temp.params.splice(1,this.temp.params.length-1)			
			this.temp.params[0].key=''
			this.innerIndex = 0
		},
		
		submitOption(){			
			if( this.questionName == ''){
				this.$message.warning('请输入问题！');
				return
			}
						
			var optionList2 = []			
			if( this.temp.params.length > 0){
				this.temp.params.forEach((tab, idx) => {
					if( tab.key != '' ){
						let obj = {
							optionName: tab.key,
							sort:idx
						}
						optionList2.push(obj)	
					}				   
				})				
			}
			if( (this.questionType == 1 || this.questionType == 2 ) && optionList2.length < 2 ){
				this.$message.warning('请至少提供2个有完整文案的选项！');				
				return
			}
			
			var obj = {
				questionName: this.questionName,
				questionType:this.questionType,
				haveOther:this.haveOther,
				optionList:optionList2,
				status:1,
				sort:0
			}
			this.formData.questionList.push(obj)			
			this.questionName = ''
			this.questionType = 1			
			this.haveOther = 0			
			this.ParamsNum = 0
			this.temp.params.splice(1,this.temp.params.length-1)			
			this.temp.params[0].key=''
			
		},
		
    }
}
</script>

<style lang="scss" scoped>
.xxIpt,.xxIpt2{
	display: flex;
	align-items: center;
	width: 100%;
	margin:0 0 10px 20px;
	span{
		padding-right: 15px;
		width: 70px;
		text-align: right;
	}
	.ipt{
		width:85%;
		
	}
}
.xxIpt2{
	.ipt{
		margin-right: 10px;
		width: 65%;
	}
}
.optionsList{
	margin-left: 90px;
	.ipt{
		width:100%;
		margin-bottom: 10px;
	}
}
// .optionsList{
// 	display: flex;
// 	align-items: center;
// 	width: 100%;
// 	.optionName{
// 		margin-left: 90px;
// 	}
// 	.el-icon-remove-outline{
// 		margin-left: 10px;
// 	}
// }
</style>